export default "__VITE_ASSET__2WX8S7KF__"